<section class="sales-panel" aria-label="Продажи и минимальный запас товара">
  <div class="sales-filters">
    <div class="period-presets" aria-label="Период продаж">
      <button mat-stroked-button type="button" (click)="preset(30)">30 дней</button>
      <button mat-stroked-button type="button" (click)="preset(90)">90 дней</button>
      <button mat-stroked-button type="button" (click)="preset(365)">Год</button>
    </div>
    <mat-form-field appearance="outline" class="date-range">
      <mat-label>Период продаж</mat-label>
      <mat-date-range-input [rangePicker]="periodPicker" [max]="calendarMaxDate">
        <input
          matStartDate
          aria-label="Начало периода продаж"
          placeholder="С"
          [ngModel]="filters.dateFrom"
          (ngModelChange)="setCalendarDate('dateFrom', $event)"
        />
        <input
          matEndDate
          aria-label="Конец периода продаж"
          placeholder="По"
          [ngModel]="filters.dateTo"
          (ngModelChange)="setCalendarDate('dateTo', $event)"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
      <mat-date-range-picker #periodPicker></mat-date-range-picker>
    </mat-form-field>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="loading || seriesLoading"
      (click)="load()"
    >
      Показать продажи
    </button>
    <button mat-stroked-button type="button"
      [disabled]="loading || seriesLoading" (click)="resetFilters()"
      title="Сбросить период и параметры отчёта">Сбросить</button>
    <mat-checkbox [ngModel]="includeAnalogues" (ngModelChange)="includeAnalogues = $event; load()"
      >TecDoc + ручные аналоги</mat-checkbox
    >
  </div>
  <p *ngIf="validationError" class="error" role="alert">{{ validationError }}</p>
  <p *ngIf="analoguesError" class="error" role="alert">{{ analoguesError }}</p>
  <div class="analogue-scope" *ngIf="!analoguesError">
    <span *ngIf="resolving" role="status">Загрузка TecDoc и ручных аналогов…</span>
    <span *ngIf="!resolving"
      >{{
        appliedAnalogues
          ? 'Товар + ' + ((applied.productIds?.length || 1) - 1) + ' аналогов'
          : 'Только этот товар'
      }}
      · все склады</span
    >
    <ng-container *ngIf="resolution as links">
      <span
        *ngFor="let source of links.sourceStates"
        class="source-state"
        [class.source-warning]="source.status !== 'ready' || !source.complete"
        [title]="source.message || ''"
      >
        {{ source.source === 'TECDOC' ? 'TecDoc' : 'Ручные' }}:
        {{ source.status === 'ready' && source.complete ? 'учтены' : 'неполные данные' }}
      </span>
      <span *ngIf="unmatchedCount" class="period-note"
        >Кроссы вне каталога: {{ unmatchedCount }}</span
      >
      <span *ngIf="ambiguousCount" class="source-warning"
        >Неоднозначные кроссы: {{ ambiguousCount }} — проверьте связи</span
      >
    </ng-container>
  </div>
  <mat-progress-bar *ngIf="loading || seriesLoading" mode="indeterminate"></mat-progress-bar>
  <p *ngIf="error" class="error" role="alert">{{ error }}</p>
  <ng-container *ngIf="report as data">
    <div class="sales-summary">
      <article>
        <span>Отгружено</span
        ><strong
          >{{ quantityLabel(data.totals, 'soldQty') }} <small>{{ unit }}</small></strong
        >
      </article>
      <article>
        <span>Возвращено</span
        ><strong
          >{{ quantityLabel(data.totals, 'returnedQty') }} <small>{{ unit }}</small></strong
        >
      </article>
      <article>
        <span>Чистые продажи</span
        ><strong
          >{{ quantityLabel(data.totals, 'netQty') }} <small>{{ unit }}</small></strong
        >
      </article>
      <article>
        <span>Выручка с возвратами</span
        ><strong>{{ number(data.totals.revenue) }} <small>грн</small></strong>
      </article>
      <article>
        <span>Отгрузок</span><strong>{{ number(data.totals.shipmentCount) }}</strong>
      </article>
      <article>
        <span>В среднем за день</span
        ><strong
          >{{ number(averageDailyQty) }} <small>{{ unit }}</small></strong
        >
      </article>
    </div>
    <p class="quality-note" *ngIf="data.quality.ambiguousDocumentsCount">
      {{ data.quality.ambiguousDocumentsCount }} документов требуют сверки. Учтите это перед
      настройкой запаса.
    </p>
  </ng-container>
  <div class="sales-workspace">
    <div class="warehouse-column">
      <ng-container *ngIf="report as data">
        <section *ngIf="data.warehouses; else missingWarehouseSales" class="warehouse-sales" aria-label="Продажи по складам">
        <div class="breakdown-heading"><h3>Продажи по складам</h3><span>{{ unit }}</span></div>
        <div class="breakdown-table-scroll" tabindex="0" role="region" aria-label="Таблица продаж по складам">
          <table>
            <thead><tr><th scope="col">Склад</th><th scope="col">Отгружено</th><th scope="col">Возвраты</th><th scope="col">Чистые</th><th scope="col">Выручка, грн</th><th scope="col" class="gross-profit" title="Выручка − себестоимость проданных товаров, с учётом возвратов">Валовая прибыль, грн</th><th scope="col" *ngIf="appliedAnalogues">Лидер склада</th></tr></thead>
            <tbody>
              <tr *ngFor="let warehouse of warehouses" [class.unassigned-warehouse]="warehouse.warehouseId === null">
                <th scope="row">{{ warehouse.warehouseName }}</th>
                <td>{{ quantityLabel(warehouse.metrics, 'soldQty') }}</td>
                <td>{{ quantityLabel(warehouse.metrics, 'returnedQty') }}</td>
                <td class="net-sales">{{ quantityLabel(warehouse.metrics, 'netQty') }}</td>
                <td>{{ number(warehouse.metrics.revenue) }}</td>
                <td class="gross-profit" [class.negative]="warehouse.metrics.profit !== null && warehouse.metrics.profit < 0" [title]="profitTooltip(warehouse.metrics)">
                  {{ number(warehouse.metrics.profit) }}
                  <small class="cost-note" *ngIf="profitCostNote(warehouse.metrics) as note">{{ note }}</small>
                </td>
                <td class="warehouse-best" *ngIf="appliedAnalogues">
                  <ng-container *ngIf="warehouse.leaders.length; else noWarehouseLeader">
                    <div *ngFor="let leader of warehouse.leaders.slice(0, 3)">
                      <a [routerLink]="['/product', leader.productId]">{{ leader.brand }} {{ leader.article }}</a>
                      <span>{{ number(leader.netQty) }} шт.</span>
                    </div>
                    <details *ngIf="warehouse.leaders.length > 3"><summary>Ещё {{ warehouse.leaders.length - 3 }} лидеров</summary>
                      <div *ngFor="let leader of warehouse.leaders.slice(3)"><a [routerLink]="['/product', leader.productId]">{{ leader.brand }} {{ leader.article }}</a><span>{{ number(leader.netQty) }} шт.</span></div>
                    </details>
                  </ng-container>
                  <ng-template #noWarehouseLeader><span class="period-note" title="Нет положительных продаж">—</span></ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="period-note">Чистые = отгрузки − возвраты. Возврат учтён на складе продажи.</p>
        <p class="quality-note" *ngIf="hasUnassignedWarehouse">Продажи без определённого склада показаны отдельной строкой и входят в общий итог.</p>
      </section>
        <ng-template #missingWarehouseSales><p class="error" role="alert">Детализация по складам недоступна. Обновите отчёт.</p></ng-template>
      </ng-container>
      <div class="stock-actions">
          <app-procurement-minimum-stock
    [productId]="productId"
    [embedded]="true"
    [autoSuggest]="true"
    [compact]="true"
    [familySources]="groupSources"
    [memberIds]="applied.productIds || []"
    [suggestionsReady]="suggestionsReady"
    [unit]="stockUnit"
    [dateFrom]="applied.dateFrom"
    [dateTo]="applied.dateTo"
    [minimumStockChanges]="minimumStockChanges"
    (minimumStockSaved)="minimumStockSaved.emit($event)"
  ></app-procurement-minimum-stock>
      </div>
    </div>
    <div class="ranking-column" *ngIf="report as data">
      <section class="analogue-ranking" *ngIf="appliedAnalogues && data.warehouses" aria-label="Рейтинг продаж товаров и аналогов по складам">
        <div class="breakdown-heading"><h3>Какие товары продаются лучше</h3><span>{{ data.totalRows }} с продажами</span></div>
        <p class="period-note">По чистым продажам, шт. ↓. Только товары с отгрузками за период.</p>
        <div class="breakdown-table-scroll ranking-table-scroll" tabindex="0" role="region" aria-label="Таблица продаж товаров и аналогов по складам">
          <table>
            <thead><tr><th scope="col">Товар / аналог</th><th scope="col">Чистые</th><th scope="col" *ngFor="let warehouse of warehouses">{{ warehouse.warehouseName }}</th><th scope="col">Отгружено</th><th scope="col">Возвраты</th><th scope="col">Выручка, грн</th><th scope="col" class="gross-profit" title="Выручка − себестоимость проданных товаров, с учётом возвратов">Валовая прибыль, грн</th></tr></thead>
            <tbody>
              <tr *ngFor="let row of data.rows" [class.anchor-product]="(row.productId || row.id) === productId">

                <td class="ranking-product" [title]="row.label"><a [routerLink]="['/product', row.productId || row.id]">{{ row.brand }} {{ row.article }}</a><small>{{ sourceLabel(row.productId || row.id) }} · шт.</small></td>
                <td class="net-sales"><span [class.leader-quantity]="isSalesLeader(row)">{{ quantityLabel(row.metrics, 'netQty') }}</span><small class="leader-label" *ngIf="isSalesLeader(row)">Лидер</small></td>
                <td *ngFor="let warehouse of warehouses"><span [class.leader-quantity]="isWarehouseLeader(row, warehouse.warehouseId)" [attr.title]="isWarehouseLeader(row, warehouse.warehouseId) ? 'Лидер продаж на этом складе' : null">{{ quantityLabel(warehouseSale(row, warehouse.warehouseId), 'netQty') }}</span></td>
                <td>{{ quantityLabel(row.metrics, 'soldQty') }}</td><td>{{ quantityLabel(row.metrics, 'returnedQty') }}</td><td>{{ number(row.metrics.revenue) }}</td>
                <td class="gross-profit" [class.negative]="row.metrics.profit !== null && row.metrics.profit < 0" [title]="profitTooltip(row.metrics)">
                  {{ number(row.metrics.profit) }}
                  <small class="cost-note" *ngIf="profitCostNote(row.metrics) as note">{{ note }}</small>
                </td>
              </tr>
            <tr *ngIf="!data.rows.length"><td class="empty-ranking" [attr.colspan]="warehouses.length + 6">За выбранный период у товара и аналогов не было отгрузок.</td></tr></tbody>
          </table>
        </div>
        <div class="ranking-pagination" *ngIf="data.totalRows > applied.pageSize">
          <span>Страница {{ applied.page }} · всего {{ data.totalRows }} с продажами</span>
          <button mat-stroked-button type="button" (click)="memberPage(applied.page - 1)" [disabled]="loading || seriesLoading || applied.page === 1">Назад</button>
          <button mat-stroked-button type="button" (click)="memberPage(applied.page + 1)" [disabled]="loading || seriesLoading || applied.page * applied.pageSize >= data.totalRows">Далее</button>
        </div>
        <p class="period-note">Зелёным — лидеры склада; при равных продажах отмечены все.</p>
        <details class="analogue-warnings" *ngIf="ambiguousCount"><summary>Неоднозначные кроссы не вошли в продажи ({{ ambiguousCount }})</summary>
          <div *ngFor="let candidate of ambiguousCandidates">{{ candidate.brand }} {{ candidate.article }} — товары: <a *ngFor="let id of candidate.productIds" [routerLink]="['/product', id]">{{ id }} </a></div>
        </details>
      </section>
      <section class="sales-dynamics">
      <div class="chart-heading">
        <h3>Отгрузки и возвраты</h3>
        <span><i class="sold-key"></i> Отгрузки <i class="returned-key"></i> Возвраты</span>
      </div>
      <p *ngIf="seriesError" class="error" role="alert">{{ seriesError }}</p>
      <div
        *ngIf="chart.length"
        class="sales-chart"
        role="img"
        aria-label="Динамика отгрузок и возвратов за выбранный период"
      >
        <div *ngFor="let point of chart" class="chart-point" [title]="point.title">
          <span class="sold-bar" [style.height.%]="point.soldHeight"></span>
          <span class="returned-bar" [style.height.%]="point.returnedHeight"></span>
        </div>
      </div>
      <div class="chart-dates" *ngIf="chart.length">
        <span>{{ applied.dateFrom | date: 'dd.MM.yyyy' }}</span
        ><span>{{ applied.dateTo | date: 'dd.MM.yyyy' }}</span>
      </div>
      <p class="period-note" *ngIf="!data.totals.shipmentCount">
        За выбранный период отгрузок выбранных товаров нет.
      </p>
    </section>
    </div>
  </div>
</section>
